import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { API_URL } from "../../../constants/index";
import { GetServiceCaller } from "../../../services/serviceCaller";
import moment from "moment";

const NiceMaster = () => {
  const todayDate = moment().format("YYYY-MM");
  console.log("todayDate",todayDate);
  
  const initialData = [
    { label: "Select Month", value: moment(todayDate).format("YYYY-MM") },
  ];

  const [searchTerm, setSearchTerm] = useState("");
  const [niceMaster, setNiceMaster] = useState([]);
  const [filterFormData, setFilterData] = useState(initialData);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalGrossAmt, setTotalGrossAmt] = useState(0);
  const [miscAmt, setTotalMiscAmt] = useState(0);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Nice Master Report"));
  }, []);

  const columns = {
    Code: { text: "NSS-Code", align: "start", visible: true },
    EmpName: { text: "Employee Name", visible: true },
    RepotingManager: { text: "Reporting Manager", visible: true },
    Designation: { text: "Designation", visible: true },
    Department: { text: "Department", visible: true },
    GrossSalary: { text: "Gross Salary", align: "end", visible: true },
    Misc: { text: "Misc", align: "end", visible: true },
    Rate: { text: "Revenue Generated", align: "end", visible: true },
    Billable: { text: "Billable (YES/NO)", align: "center", visible: true },
    Technical: { text: "Technical (YES/NO)", align: "center", visible: true },
  };

  const formDatas = [{ name: "Select Month", type: "Date" }];

  //   const handleChange = (e, name) => {
  //     console.log("tests the server", e, name);

  //     setFilterData((prevFormData) => {
  //       // Check if the label already exists
  //       const existingLabelIndex = prevFormData.findIndex(
  //         (item) => item.label === name
  //       );

  //       // If the label exists, update its value
  //       if (existingLabelIndex !== -1) {
  //         const updatedFormData = prevFormData.map((item, index) =>
  //           index === existingLabelIndex
  //             ? { ...item, value: e.value !== undefined ? e.value : e }
  //             : item
  //         );
  //         return updatedFormData;
  //       } else {
  //         // If the label doesn't exist, add a new label-value pair
  //         return [
  //           ...prevFormData,
  //           {
  //             label: name,
  //             value: e.value !== undefined ? e.value : e, // Assuming e is an event object
  //           },
  //         ];
  //       }
  //     });
  //   };
  const handleChange = (e, name) => {
    // Convert the date to "YYYY-MM" format if it's a valid date
    const formattedValue = moment(e, "DD-MMM-YYYY").isValid()
      ? moment(e, "DD-MMM-YYYY").format("YYYY-MM")
      : e;
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? {
                ...item,
                value: formattedValue !== undefined ? formattedValue : e,
              }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: formattedValue !== undefined ? formattedValue : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchNiceMaster = async () => {
    SetApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/6?StartMonth=`
      );
      SetApiStatus(response?.status);      
      if (response.status === 200) {
        const niceData = response?.data?.data?.data;
        setNiceMaster(Object.values(niceData));
        const GrossAmt = response?.data?.data?.data?.TotalGRS;
        setTotalGrossAmt(GrossAmt);
        const MiscAmt = response?.data?.data?.data?.TotalMisc;
        setTotalMiscAmt(MiscAmt);
        const Revenue = response?.data?.data?.data?.TotalREV;
        setTotalRevenue(Revenue);
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };

  useEffect(() => {
    fetchNiceMaster();
  }, []);
  const handleGetData =async () => {
    SetApiStatus(undefined)
     try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/6?StartMonth=${
          filterFormData.find((o) => o.label === "Select Month")
            ? moment(
                filterFormData.find((o) => o.label === "Select Month").value
              ).format("YYYY-MM")
            : "2024-01"
        }`
      );
      SetApiStatus(response?.status);      
      if (response.status === 200) {
        const niceData = response?.data?.data?.data;
        setNiceMaster(Object.values(niceData));
        const GrossAmt = response?.data?.data?.data?.TotalGRS;
        setTotalGrossAmt(GrossAmt);
        const MiscAmt = response?.data?.data?.data?.TotalMisc;
        setTotalMiscAmt(MiscAmt);
        const Revenue = response?.data?.data?.data?.TotalREV;
        setTotalRevenue(Revenue);
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };

  const handleReset = ()=>{
setFilterData(initialData)
fetchNiceMaster()
  }


  const ReadOnlyValues =[
    {
    label:" Total Gross Amt.",value:Number(totalGrossAmt).toLocaleString("en-IN")
  },
    {
    label:" Total Misc ",value:Number(miscAmt).toLocaleString("en-IN")
  },
    {
    label:"Total Revenue",value:Number(totalRevenue).toLocaleString("en-IN")
  },
]
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
        
          <div className="row">
            <Dynamic_PR_table
              data={niceMaster}
              columns={columns}
            ReadOnlyValues={ReadOnlyValues}
              itemsPerPage={10}
              isSorting={true}
              showIcon1={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              searchTerm={searchTerm}
              handleReset={handleReset}
              setSearchTerm={setSearchTerm}
              formDatas={formDatas}
              isFilterRequired={true}
              filterFormData={filterFormData}
              handleGetData={handleGetData}
              handleChange={handleChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NiceMaster;
